<template>
  <div>
    <el-dialog :visible.sync="visibleDialog" :fullscreen="fullscreen" :close-on-click-modal="false" :close-on-press-escape="false" v-bind="$attrs" v-on="$listeners" :append-to-body="true">
      <template #title>
        <slot name="title">
          <h2 class="text-lg">{{ title }}</h2>
        </slot>
      </template>

      <!--内容区域插槽-->
      <slot name="content"></slot>

      <template #footer>
        <!--对外暴漏footer插槽，个别按钮进行自定义-->
        <slot name="footer" v-if="showBtn">
          <!--默认集成确定与取消按钮-->
          <el-button :size="size" @click="$handleCancel">取 消</el-button>
          <el-button :size="size" type="primary" @click="$handleConfirm">确 定 </el-button>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'JrDialog',
  props: {
    // 弹窗标题
    title: {
      type: String,
      default: 'dialog窗口'
    },
    // 对外暴漏visible属性，用于显示于隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 内置按钮大小
    size: {
      type: String,
      default: 'mini'
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      fullscreen: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 对外抛出cancle事件
    $handleCancel() {
      this.$emit('cancel')
    },
    // 对外抛出confirm事件
    $handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss">
.el-dialog__header {
  padding: 20px;
  background-color: #f8f8f8;

  h2 {
    font-size: 20px;
  }
}

.el-dialog__headerbtn {
  top: 10px;
}

.el-dialog__body {
  padding: 10px 20px;
  color: #606266;
}

.el-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0 !important;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
}

.el-dialog__body {
  overflow: auto;
}
</style>
